import React, { useState, useEffect } from 'react'
import api from '../../API/api'
import Swal from 'sweetalert2';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';


const Affiliation = (props) => {
    const [Affiliation, setAffiliation] = useState();

    const [all, setAll] = useState();


    useEffect(() => {
        getAffiliations();
    }, [])

    const getAffiliations = () => {
        api.getAffiliations().then((res) => {
            // console.log(res);
            setAll(res.data.affiliations)
        })
            .catch((err) => {
                // console.log(err);
            })
    }

    const saveAffiliation = () => {
        if (!Affiliation) {
            props.handleClose();
            Swal.fire({
                title: 'Opps!',
                text: 'Please Enter Affiliation!',
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            return;
        }

        api.saveAffiliation(Affiliation).then((res) => {
            // console.log(res);
            props.handleClose();
            Swal.fire({
                title: 'Success!',
                text: 'Added Succeffully !',
                icon: 'success',
                confirmButtonText: 'Ok'
            })
            getAffiliations();
        })
            .catch((err) => {
                // console.log(err);
            })
    }




    return (
        <>
            <div>
                <div className="row">
                    <div className="col-12 m-2">
                        <label htmlFor="">Affiliation Name</label>
                        <input type="text" className='form-control' name="affiliation" onChange={(e) => setAffiliation(e.target.value)} id="" placeholder='Enter Affiliation name' />
                    </div>

                    <div className="col-12 m-2 text-center">
                        <button className='btn btn-success' onClick={saveAffiliation}>+ Add New Affiliation </button>
                    </div>
                </div>
            </div>

            <hr />
            <div className='mt-4 pt-3'>

                <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
                        <TableHead>
                            <TableRow className='bg-primary'>
                                <TableCell>Affiliation</TableCell>
                                <TableCell align="right">Status</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {all && all.map((row) => (
                                <TableRow
                                    key={row.name}
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                >
                                    <TableCell component="th" scope="row">
                                        {row.affiliation}
                                    </TableCell>
                                    <TableCell align="right">{row.isActive == 1 ? <span className='text-success'> Active </span> : <span className='text-danger'> Inactive </span>}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>

            </div>



        </>
    )
}

export default Affiliation;